import { useCallback, useEffect, useRef } from 'react';
import { TermsAndConditionsList } from '@/components/_promo/components/TermsAndConditionsList';

interface IOfferTermsProps {
  isCardRotate: boolean;
  translation: string;
  validDate?: string;
  defaultFsCount?: number;
}

export const OfferTerms = ({
  translation,
  validDate,
  isCardRotate,
  defaultFsCount,
}: IOfferTermsProps) => {
  const termsWrapperRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const el = termsWrapperRef.current;
    if (!el) return;
    el.dataset.atBottom = String(
      el.scrollTop + el.clientHeight >= el.scrollHeight
    );
  }, []);

  useEffect(() => {
    if (!isCardRotate) return;
    const el = termsWrapperRef.current;
    if (!el) return;
    el.dataset.atBottom = String(
      el.scrollTop + el.clientHeight >= el.scrollHeight
    );
  }, [isCardRotate]);

  return (
    <div
      className="terms-wrapper"
      data-at-bottom="false"
      onScroll={handleScroll}
      ref={termsWrapperRef}
    >
      <TermsAndConditionsList
        defaultFsCount={defaultFsCount}
        translation={translation}
        validDate={validDate}
      />
    </div>
  );
};
